import type {LidarTechnology, LidarTechnologyType} from '@/domain/entities/LidarTechnology';
import type {LidarTechnologyDto} from './LidarTechnologyDto';

export const toDomain = (dto: LidarTechnologyDto): LidarTechnology => ({
  ...dto,
  type: dto.type as LidarTechnologyType,
});
